<div class="px-3 d-flex justify-content-between align-items-center quarter-info" *ngIf="quarterRebateMessage">
  <div class="quarter-message" [innerHTML]="quarterRebateMessage | safeHtml"></div>
  <a class="btn btn-upload d-flex align-items-center mt-2 mb-2" *ngIf="showRebateButton" [routerLink]="'/rebate-claim'">
    {{ 'Rebate Claim' | translate }}
    <fa-icon class="ms-2" [icon]="['far', 'chevron-right']"></fa-icon>
  </a>
</div>
